@if (labels.length > 1) {
  <div
    class="atlas-navbar__tab-header__label-container"
    >
    <div class="atlas-navbar__tab-header__tab-list">
      <div class="atlas-navbar__tab-header__tab-list__labels">
        @for (label of labels; track label) {
          <div
            class="atlas-navbar__tab-header__tab"
        [class.atlas-navbar__tab-header__tab--active]="
          label === (activeLabel$$ | async)
        "
            (click)="setActive(label)"
            [attr.id]="'atlas-navbar__tab__' + label"
            >
            <div class="atlas-navbar__tab-header__tab__label">
              {{ label }}
            </div>
          </div>
        }
      </div>
      <atlas-ink-bar></atlas-ink-bar>
    </div>
  </div>
}
